import React from "react";
import Slot from "./Slot";
import { Row, Typography } from "antd";

function RenderSlot({
  label,
  availability,
  updateItem,
  practitioner,
  reason,
  matchingRequest,
  practiceId,
  reservationRequest,
  deleteReservationRequest,
  themeColor,
  date,
}) {
  return (
    <>
      {availability && availability.length <= 0 && (
        <Typography.Text type="secondary">
          {label}: No slots available
        </Typography.Text>
      )}

      {availability && availability.length > 0 && (
        <Row>
          {availability?.map((startTime, index) => (
            <Slot
              themeColor={themeColor}
              date={date}
              startTime={startTime}
              updateItem={updateItem}
              practitioner={practitioner}
              reason={reason}
              doesMatching={
                matchingRequest && matchingRequest.startTime === startTime
              }
              practiceId={practiceId}
              reservationKey={matchingRequest?.reservationKey}
              anyBatch={matchingRequest?.anyBatch}
              reservationRequest={reservationRequest}
              deleteReservationRequest={deleteReservationRequest}
            />
          ))}
        </Row>
      )}
    </>
  );
}

export default RenderSlot;
